/**
 * created by lei lei on 2020/6/4
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Layout, Button, message, Affix, Icon} from 'antd';
export default class BaseCustomInterface extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {
            showBtnStatus: false,//右侧按钮状态，默认是收起的
        }
        this.showBtnStatus=this.state.showBtnStatus
    }

    componentWillMount() {
    }

    componentDidMount() {
    }
    //渲染页面右侧弹出抽屉按钮
    renderRightBtn() {
        return (
            <div style={{position: 'fixed', top: 400, right: 10, zIndex: '1000'}}>
                <Button onClick={()=>{
                    this.showBtnStatus=true
                    this.setState({showBtnStatus:true})
                }}><Icon type="double-left"/></Button>
            </div>
        )
    }
    /*渲染页面右侧收回抽屉按钮*/
    renderCommonBtn(btnList){
        if(this.state.showBtnStatus){
            return(
                <div style={{position:'fixed',top:160,right:10,zIndex:'1000',width:300,background:'white',border:'1px solid #ececec',padding:20,textAlign:'center'}}>
                    <div style={{position: 'fixed', top: 400, right: 310, zIndex: '1000'}}>
                        <Button onClick={()=>{
                            this.showBtnStatus=false
                            this.setState({showBtnStatus:false})
                        }}><Icon type="double-right"/></Button>
                    </div>
                    {btnList.map((item,i)=>{
                        return(
                            <Button type="primary" style={{width:200,height:40,marginTop:10}} key={i} onClick={()=>this.addChart(item.key)}>{item.title}</Button>
                        )
                    })}
                </div>
            )
        }

    }

}